import React, { useEffect, useState } from 'react';
import InputField from '../../components/Forms/InputField';
import RichTextEditor from '../../components/Forms/RichTextEditor';
import { ActionButton } from '../../components/Forms/ActionButton';
import NewDropdown from '../../components/Forms/NewDropdown';
import ChallengeInformation from './components/ChallengeInformation';
import { challengeCategoryList, challengeEditView, createChallenge, editChallenge, getSuggestedUsersList } from '../../api/challenge';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation, useNavigate } from 'react-router-dom';
import SubmissionInformation from './components/SubmissionInformation';
import Chip from '../../components/Chip';
import { useGetProductsList } from '../../queries/products';

const CreateChallenge = () => {
    const navigate = useNavigate();

    const { state } = useLocation();
    const {
        challengeName,
        challengeDescription,
        challengeInspireMe,
        challengeProposedByUser,
        challengeCategory,
        proposedChallengeId,
        challengeCoverImage
    } = state || {};
    const id = state?._id || null;
    
    const [challengeId, setChallengeId] = useState(id);
    const [selectedTab, setSelectedTab] = useState('challenge-information'); // [ challenge-information, submission-information, products/services ]
    const [questionType, setQuestionType] = useState('text');
    const [active, setActive] = useState(false);
    const [allowEarlySubmission, setAllowEarlySubmission] = useState(false);
    const [allowLateSubmission, setAllowLateSubmission] = useState(false);

    const [statecoverImage, setStateCoverImage] = useState(null);
    const [coverImage, setCoverImage] = useState(challengeCoverImage || '');
    const [data, setData] = useState([]);
    const [userData, setUserData] = useState([]);

    const [isSponsored, setIsSponsored] = useState(false);
    
    const [name, setName] = useState(challengeName || '');
    const [category, setCategory] = useState(challengeCategory?._id || '');
    const [complexity, setComplexity] = useState('');
    const [suggestedBy, setSuggestedBy] = useState('');
    const [disabledFriendly, setDisabledFriendly] = useState('');
    const [recurrent, setRecurrent] = useState('');
    const [recurrentDuration, setRecurrentDuration] = useState('');
    const [typeOfFrequency, setTypeOfFrequency] = useState('');
    const [frequency, setFrequency] = useState('once');
    const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
    const [endDate, setEndDate] = useState(() => {
        const today = new Date();
        today.setFullYear(today.getFullYear() + 4);
        return today.toISOString().split('T')[0];
    });
    const [description, setDescription] = useState(challengeDescription || '');
    const [inspireMe, setInspireMe] = useState(challengeInspireMe || '');
    const [rewardDetails, setRewardDetails] = useState('');
    const [bonusDetails, setBonusDetails] = useState('');
    const [bonusPoints, setBonusPoints] = useState(0);
    const [sponsoredPoints, setSponsoredPoints] = useState('');
    const [totalPoints, setTotalPoints] = useState(0);
    const [carbonEmissionCount, setCarbonEmissionCount] = useState('');
    const [carbonEmissionInfo, setCarbonEmissionInfo] = useState('');
    const [carbonSavingPoints, setCarbonSavingPoints] = useState(0);

    const [submissionProvision, setSubmissionProvision] = useState('');

    const [submissionButtonType, setSubmissionButtonType] = useState('end');
    const [tips, setTips] = useState([
        {
            title: "",
            description: "",
            media: "",
            stateMedia: null,
            buttonName: "",
            buttonLink: "",
        }
    ]);
    const [errors, setErrors] = useState([]);

    const [pages, setPages] = useState([]);

    const [questions, setQuestions] = useState([]);
    const [bonusPage, setBonusPage] = useState([]);

    const [productVisible, setProductVisible] = useState(false);
    const [attachedProduct, setAttachedProduct] = useState('');
    const [productTitle, setProductTitle] = useState('');
    const [productLink, setProductLink] = useState('');
    const [productDescription, setProductDescription] = useState('');
    const [productImage, setProductImage] = useState(null);

    // Prevent duplicate requests
    const [isSavingDraft, setIsSavingDraft] = useState(false);
    const [isSubmittingFinal, setIsSubmittingFinal] = useState(false);

    // App Configuration States
    const [appDisplay, setAppDisplay] = useState(false);
    const [moreChallenges, setMoreChallenges] = useState(false);
    const [recommendedChallenges, setRecommendedChallenges] = useState(false);
    const [challengeOfTheDay, setChallengeOfTheDay] = useState(false);

    const { data: productsList, isLoading: isProductsLoading } = useGetProductsList();
    
    // useEffect(() => {
    //     if (state != null && state._id != null) {
    //         challengeEditView(state._id, data, setData, setChallengeInformation, toast);
    //     }
    // }, []);

    useEffect(() => {
        if(productsList && productsList.length > 0){
            
        }  
    }, [productsList]);
    
    const handleChallengeInformationSubmit = (e) => {
        e.preventDefault();
        if (active) {
            const errors = [];
            if (!name) errors.push('Name Of Challenge');
            if (!category) errors.push('Challenge Category');
            if (!recurrent) errors.push('Type Of Challenge');
            setErrors(errors);
            // console.log(errors);
            if (errors.length > 0) {
                return;
            }
            setSelectedTab('submission-information');
        }
        else {
            setSelectedTab('submission-information');
        }
    }

    const handleSubmissionInformationSubmit = (e) => {
        e.preventDefault();
        if (active) {
            const errors = [];
            if (pages.length === 0) errors.push('Please At least Add One Page');
            else if (pages[0].questions.length === 0) errors.push('Please At least Add One Question To The Page');
            setErrors(errors);
            if (errors.length > 0) {
                return;
            }
            setSelectedTab('products/services');
        }
        else {
            setSelectedTab('products/services');
        }
    }

    const handleFinalSubmission = e => {
        console.log(suggestedBy);
        e.preventDefault();
        if (isSubmittingFinal) {
            toast.info('Submission in progress. Please wait...');
            return;
        }
        setIsSubmittingFinal(true);
        // const errors = [];
        // if (!productVisible) errors.push('Product/Service Visibility');
        // if (productVisible === 'true') {
        //     if (!productTitle) errors.push('Product/Service Title');
        //     if (!productLink) errors.push('Product/Service Link');
        //     if (!productDescription) errors.push('Product/Service Description');
        //     if (!productImage) errors.push('Product/Service Image');
        // }
        // setErrors(errors);
        // if (errors.length > 0) {
        //     return;
        // }
        const challengeData = {
            active: active,
            name: name,
            description: description,
            inspireMe: inspireMe,
            points: Number(totalPoints),
            bonusPoints: Number(bonusPoints),
            recurrent: recurrent.value ? recurrent.value : recurrent,
            startDate: startDate,
            endDate: endDate,
            typeOfFrequency: typeOfFrequency,
            frequency: frequency || 'once',
            inclusive: disabledFriendly === 'true' ? true : false,
            complexity: complexity,
            tips: tips,
            rewardDetails: rewardDetails,
            bonusDetails: bonusDetails,
            pagesAndQuestions: pages,
            category: category || data[0]?._id,
            suggestedBy: suggestedBy,
            recurrentDuration: recurrentDuration,
            sponsoredPoints: Number(sponsoredPoints),
            productVisible: productVisible === 'true' ? true : false,
            attachedProduct: attachedProduct,
            product: {
                title: productTitle,
                link: productLink,
                description: productDescription,
                image: productImage
            },
            submissionProvision: submissionProvision,
            displaySubmissionButton: submissionButtonType,
            doYouKnowSection: appDisplay || false, // Add Challenge to "Do You Know?" Section
            moreChallenges: moreChallenges, // More challenges in home page
            recommendedChallenge: recommendedChallenges, // Recommended challenges
            challengeOfTheDay: false, // Challenge Of The Day
            carbonEmissionCount: carbonEmissionCount,
            carbonEmissionInfo: carbonEmissionInfo,
            carbonSavingPoints: carbonSavingPoints,
            proposedChallengeId: proposedChallengeId || null,
        };
        // console.log(challengeData);
        // console.log(challengeId);
        // wrapper to reset submitting state when backend sets the id
        const finishCallback = (id) => {
            setChallengeId(id);
            setIsSubmittingFinal(false);
            setIsSavingDraft(false);
        };

        if (challengeId) {
            editChallenge(challengeId, challengeData, coverImage, toast, "Challenge Successfully Submitted", navigate, false, finishCallback);
        } else {
            createChallenge(challengeData, coverImage, toast, "Challenge Successfully Submitted", navigate, false, finishCallback);
        }
        // Fallback: clear submitting flag after 15s to avoid stuck UI if backend callback isn't invoked
        setTimeout(() => {
            setIsSubmittingFinal(false);
            setIsSavingDraft(false);
        }, 15000);
    }

    const handleSaveDraft = e => {
        e.preventDefault();
        if (isSavingDraft) {
            toast.info('Save in progress. Please wait...');
            return;
        }
        setIsSavingDraft(true);

        const challengeData = {
            active: active,
            name: name,
            description: description,
            inspireMe: inspireMe,
            points: Number(totalPoints),
            bonusPoints: Number(bonusPoints),
            recurrent: recurrent.value ? recurrent.value : recurrent,
            startDate: startDate,
            endDate: endDate,
            typeOfFrequency: typeOfFrequency,
            frequency: frequency || 'once',
            inclusive: disabledFriendly === 'true' ? true : false,
            complexity: complexity,
            tips: tips,
            rewardDetails: rewardDetails,
            bonusDetails: bonusDetails,
            pagesAndQuestions: pages,
            category: category || data[0]?._id,
            suggestedBy: suggestedBy,
            recurrentDuration: recurrentDuration,
            sponsoredPoints: Number(sponsoredPoints),
            productVisible: productVisible === 'true' ? true : false,
            attachedProduct: attachedProduct,
            product: {
                title: productTitle,
                link: productLink,
                description: productDescription,
                image: productImage
            },
            submissionProvision: submissionProvision,
            submissionButtonType: submissionButtonType,
            doYouKnowSection: false, // Add Challenge to "Do You Know?" Section
            moreChallenges: moreChallenges, // More challenges in home page
            recommendedChallenge: recommendedChallenges, // Recommended challenges
            challengeOfTheDay: challengeOfTheDay || false, // Challenge Of The Day
            carbonEmissionCount: carbonEmissionCount,
            carbonEmissionInfo: carbonEmissionInfo,
            carbonSavingPoints: carbonSavingPoints,
            proposedChallengeId: proposedChallengeId || null,
        };
        // console.log(challengeData);
        // wrapper to reset saving state when backend sets the id
        const finishCallback = (id) => {
            setChallengeId(id);
            setIsSavingDraft(false);
        };

        if (challengeId) {
            editChallenge(challengeId, challengeData, coverImage, toast, "Challenge Saved as Draft", navigate, true, finishCallback);
        } else {
            createChallenge(challengeData, coverImage, toast, "Challenge Saved as Draft", navigate, true, finishCallback);
        }
        // Fallback: clear saving flag after 15s to avoid stuck UI if backend callback isn't invoked
        setTimeout(() => {
            setIsSavingDraft(false);
        }, 15000);
    }

    const calculateTotalPoints = () => {
        let tp = 0;
        let bp = 0;
        if (!pages || pages.length === 0) return tp, bp;
        pages.forEach(page => {
            if (page.isBonusPage) {
                if (page.questions.length === 0) return bp;
                page.questions.forEach(question => {
                    bp += parseInt(question.points) || 0;
                });
            } else {
                if (page.questions.length === 0) return tp;
                page.questions.forEach(question => {
                    tp += parseInt(question.points) || 0;
                });
            }
        });
        setTotalPoints(tp);
        setBonusPoints(bp);
    }

    const updateQuestion = (pageIndex, questionIndex, updatedQuestion) => {
        const updatedPages = [...pages];

        // Handle default points for media type questions
        if (updatedQuestion.questionType === 'media') {
            // Set default points based on media type if the points weren't set manually
            if (updatedQuestion.mediaType === 'image' &&
                (!updatedQuestion.points || updatedQuestion.isDefaultPoints)) {
                updatedQuestion.points = '100';
                updatedQuestion.isDefaultPoints = true;
            } else if (updatedQuestion.mediaType === 'video' &&
                (!updatedQuestion.points || updatedQuestion.isDefaultPoints)) {
                updatedQuestion.points = '200';
                updatedQuestion.isDefaultPoints = true;
            }
        } else if (updatedQuestion.isDefaultPoints) {
            // If changing from media type to another type, remove the default flag
            updatedQuestion.isDefaultPoints = false;
        }

        updatedPages[pageIndex].questions[questionIndex] = updatedQuestion;
        setPages(updatedPages);
    };

    const renderTab = () => {
        if (selectedTab === 'challenge-information') {
            return (
                <ChallengeInformation
                    navigate={navigate}
                    active={active}
                    name={name}
                    setName={setName}
                    category={category}
                    setCategory={setCategory}
                    complexity={complexity}
                    setComplexity={setComplexity}
                    suggestedBy={suggestedBy}
                    setSuggestedBy={setSuggestedBy}
                    disabledFriendly={disabledFriendly}
                    setDisabledFriendly={setDisabledFriendly}
                    recurrent={recurrent}
                    setRecurrent={setRecurrent}
                    recurrentDuration={recurrentDuration}
                    setRecurrentDuration={setRecurrentDuration}
                    typeOfFrequency={typeOfFrequency}
                    setTypeOfFrequency={setTypeOfFrequency}
                    frequency={frequency}
                    setFrequency={setFrequency}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                    description={description}
                    setDescription={setDescription}
                    inspireMe={inspireMe}
                    setInspireMe={setInspireMe}
                    bonusPoints={bonusPoints}
                    rewardDetails={rewardDetails}
                    setRewardDetails={setRewardDetails}
                    setBonusPoints={setBonusPoints}
                    sponsoredPoints={sponsoredPoints}
                    setSponsoredPoints={setSponsoredPoints}
                    totalPoints={totalPoints}
                    setTotalPoints={setTotalPoints}
                    handleChallengeInformationSubmit={handleChallengeInformationSubmit}
                    tips={tips}
                    setTips={setTips}
                    submissionButtonType={submissionButtonType}
                    setSubmissionButtonType={setSubmissionButtonType}
                    coverImage={coverImage}
                    setCoverImage={setCoverImage}
                    stateCoverImage={statecoverImage}
                    setStateCoverImage={setStateCoverImage}
                    errors={errors}
                    usersData={userData}
                    categoryData={data}
                    carbonEmissionCount={carbonEmissionCount}
                    setCarbonEmissionCount={setCarbonEmissionCount}
                    carbonEmissionInfo={carbonEmissionInfo}
                    setCarbonEmissionInfo={setCarbonEmissionInfo}
                    bonusDetails={bonusDetails}
                    setBonusDetails={setBonusDetails}
                    handleSaveDraft={handleSaveDraft}
                    carbonSavingPoints={carbonSavingPoints}
                    setCarbonSavingPoints={setCarbonSavingPoints}
                />
            );
        }
        else if (selectedTab === 'submission-information') {
            return (
                <SubmissionInformation
                    navigate={navigate}
                    active={active}
                    questionType={questionType}
                    setQuestionType={setQuestionType}
                    allowEarlySubmission={allowEarlySubmission}
                    setAllowEarlySubmission={setAllowEarlySubmission}
                    allowLateSubmission={allowLateSubmission}
                    setAllowLateSubmission={setAllowLateSubmission}
                    questions={questions}
                    setQuestions={setQuestions}
                    handleSubmissionInformationSubmit={handleSubmissionInformationSubmit}
                    pages={pages}
                    setPages={setPages}
                    totalPoints={totalPoints}
                    calculateTotalPoints={calculateTotalPoints}
                    setSelectedTab={setSelectedTab}
                    errors={errors}
                    setErrors={setErrors}
                    setSubmissionButtonType={setSubmissionButtonType}
                    submissionProvision={submissionProvision}
                    setSubmissionProvision={setSubmissionProvision}
                    updateQuestion={updateQuestion}
                    bonusPage={bonusPage}
                    setBonusPage={setBonusPage}
                    handleSaveDraft={handleSaveDraft}
                />
            );
        }
        else if (selectedTab === 'products/services') {
            return (
                <form className='mt-7'>
                    {/* Attach Product */}
                    <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full">
                        <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">Attach Product</label>
                        <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                            <NewDropdown
                                name="attachedProduct"
                                onChange={(selectedOption) => setAttachedProduct(selectedOption.value)}
                                requiredMessage={false}
                                dataList={productsList}
                                placeholder="Select a product"
                                value={attachedProduct}
                                allowMultiple={false}
                                disabled={isProductsLoading}
                            />
                        </div>
                        {errors.includes('Attached Product') && (
                            <span className="text-red text-sm font-bold">Attached Product is required</span>
                        )}
                    </div>

                    <div className='flex justify-between mt-10'>
                        <ActionButton variant={'reset'} text={'Reset'} />
                        <div className='flex gap-2.5'>
                            {
                                !active &&
                                <div className='flex justify-end'>
                                    <ActionButton
                                        text={'Save Draft'}
                                        variant={'white'}
                                            handleSubmit={handleSaveDraft}
                                            disabled={isSavingDraft}
                                    />
                                </div>
                            }
                            <ActionButton variant={'cancel'} text={'Cancel'} handleSubmit={() => navigate('/challenges/challenges-main/view-challenges')} />
                            <ActionButton variant={'prev'} text={'< Previous'} handleSubmit={() => setSelectedTab('submission-information')} />
                            <ActionButton variant={'submit'} text={'Next >'} handleSubmit={() => setSelectedTab('App Display Configuration')} />
                        </div>
                    </div>
                </form>
            );
        }
        else if (selectedTab === 'App Display Configuration') {
            return (
                <form>
                    <div>
                        <h1 className='text-xl font-semibold'>App Display Configuration</h1>
                        <p className='text-base text-gray-500'>Configure the display of your challenge on the app</p>
                    </div>
                    {/* <div className='flex gap-2 mt-5 items-center'>
                        <label className="inline-flex items-center me-0 cursor-pointer h-full">
                            <input type="checkbox" name={'challengeOfTheDay'} value={challengeOfTheDay} className="sr-only peer" onChange={() => setChallengeOfTheDay(!challengeOfTheDay)} checked={challengeOfTheDay} />
                            <div className="relative w-8 h-4 bg-white border-black ring-1 ring-inactive rounded-full peer dark:bg-white peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.1 after:start-[0px] after:bg-inactive after:border-inactive peer-checked:after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-navBtn peer-checked:ring-primary peer-checked:bg-primary"></div>
                        </label>
                        <h1 className='text-base font-semibold'>Challenge of the day</h1>
                    </div> */}
                    <div className='flex gap-2 mt-5'>
                        {/* <input type="checkbox" name="appDisplay" id="appDisplay" value={appDisplay} onChange={() => setAppDisplay(!appDisplay)} /> */}
                        {/* <h1 className='text-base font-semibold'>Add Challenge to "Do You Know?" Section</h1> */}
                    </div>
                    <div className='flex gap-2 mt-5'>
                        <input type="checkbox" name="moreChallenges" id="moreChallenges" checked={moreChallenges} onChange={() => setMoreChallenges(!moreChallenges)} />
                        <h1 className='text-base font-semibold'>More challenges in home page</h1>
                    </div>
                    <div className='flex gap-2 mt-5'>
                        <input type="checkbox" name="recommendedChallenges" id="recommendedChallenges" checked={recommendedChallenges} onChange={() => setRecommendedChallenges(!recommendedChallenges)} />
                        <h1 className='text-base font-semibold'>Recommended challenges</h1>
                    </div>
                    <div className='flex justify-between mt-10'>
                        <ActionButton variant={'reset'} text={'Reset'} />
                        <div className='flex gap-2.5'>
                            {
                                !active &&
                                <div className='flex justify-end'>
                                    <ActionButton
                                        text={'Save Draft'}
                                        variant={'white'}
                                        handleSubmit={handleSaveDraft}
                                        disabled={isSavingDraft}
                                    />
                                </div>
                            }
                            <ActionButton variant={'cancel'} text={'Cancel'} handleSubmit={() => navigate('/challenges/challenges-main/view-challenges')} />
                            <ActionButton variant={'prev'} text={'< Previous'} handleSubmit={() => {
                                // setSelectedTab('products/services');
                                setSelectedTab('submission-information');
                            }} />
                            <ActionButton variant={'submit'} text={'Submit'} handleSubmit={e => handleFinalSubmission(e)} disabled={isSubmittingFinal} />
                        </div>
                    </div>
                </form>
            );
        }
    }

    useEffect(() => {
        challengeCategoryList(setData, toast);
        getSuggestedUsersList(setUserData, toast);
        if(challengeProposedByUser){
            setSuggestedBy(challengeProposedByUser?.userId);
        }
    }, []);

    useEffect(() => {
        if (id) {
            challengeEditView({
                id,
                setCoverImage,
                setActive,
                setName,
                setCategory,
                setComplexity,
                setSuggestedBy,
                setDisabledFriendly,
                setRecurrent,
                setRecurrentDuration,
                setTypeOfFrequency,
                setFrequency,
                setStartDate,
                setEndDate,
                setDescription,
                setInspireMe,
                setRewardDetails,
                setBonusPoints,
                setSponsoredPoints,
                setTotalPoints,
                setTips,
                setPages,
                setSubmissionProvision,
                setSubmissionButtonType,
                setProductVisible,
                setAttachedProduct,
                setAppDisplay,
                setMoreChallenges,
                setRecommendedChallenges,
                setChallengeOfTheDay,
                setCarbonEmissionCount,
                setCarbonEmissionInfo,
                setBonusDetails,
                setCarbonSavingPoints,
                setIsSponsored,
                toast
            });
        }
    }, [id]);

    useEffect(() => {
        calculateTotalPoints();
    }, [pages]);

    return (
        <div className='w-full'>
            <div className='flex text-base justify-end gap-2 mb-2'>
                {
                    isSponsored &&
                    <div className='flex h-fit w-fit items-end justify-end'>
                        <Chip
                            value={'Sponsored'}
                            color={'blue'}
                        />
                    </div>
                }
                <div className="flex justify-center items-center gap-3">
                    <p className='font-bold text-base'>Status</p>
                    <div className={`flex justify-end items-center border ${active ? `border-primary` : `border-inactive`} rounded-md h-full min-h-8 min-w-20`}>
                        <label className="inline-flex items-center me-5 cursor-pointer h-full">
                            <span className={`ms-3 text-base ${active ? `text-primary` : 'text-inactive'} font-bold dark:text-gray-300 mr-2`}>{active ? 'Active' : 'Inactive'}</span>
                            <input type="checkbox" name={'active'} value={active} className="sr-only peer" onChange={() => setActive(!active)} checked={active} />
                            <div className="relative w-8 h-4 bg-white border-black ring-1 ring-inactive rounded-full peer dark:bg-white peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.1 after:start-[0px] after:bg-inactive after:border-inactive peer-checked:after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-navBtn peer-checked:ring-primary peer-checked:bg-primary"></div>
                        </label>
                    </div>
                </div>
                {/* <div className="flex justify-center items-center gap-3">
                    <p className='font-bold text-base'>Challenge Of The Day</p>
                    <div className={`flex justify-end items-center border ${challengeOfTheDay ? `border-primary` : `border-inactive`} rounded-md h-full min-h-8 min-w-20`}>
                        <label className="inline-flex items-center me-5 cursor-pointer h-full">
                            <span className={`ms-3 text-base ${challengeOfTheDay ? `text-primary` : 'text-inactive'} font-bold dark:text-gray-300 mr-2`}>{challengeOfTheDay ? 'Yes' : 'No'}</span>
                            <input type="checkbox" name={'challengeOfTheDay'} value={challengeOfTheDay} className="sr-only peer" onChange={() => setChallengeOfTheDay(!challengeOfTheDay)} checked={challengeOfTheDay} />
                            <div className="relative w-8 h-4 bg-white border-black ring-1 ring-inactive rounded-full peer dark:bg-white peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.1 after:start-[0px] after:bg-inactive after:border-inactive peer-checked:after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-navBtn peer-checked:ring-primary peer-checked:bg-primary"></div>
                        </label>
                    </div>
                </div> */}
            </div>
            <div className="flex w-full flex-col px-4 pt-5 pb-14 bg-white rounded-md shadow-[0px_4px_25px_rgba(94,92,154,0.1)] max-md:pt-24">
                {/* Tabs */}
                <div className='w-full sticky top-[3.7rem] bg-white z-30 pt-2 border-b border-border'>
                    <div className='flex justify-between items-center text-base gap-2'>
                        <h1 className='font-bold'>{name}</h1>
                        <div className='flex justify-between items-center gap-5'>
                            <div className='flex gap-1'>
                                <p className='font-bold'>Carbon Saving Points: </p>
                                <p className='font-bold text-primary'>{carbonSavingPoints}</p>
                            </div>
                            <div className='flex gap-1'>
                                <p className='font-bold'>Submission Points: </p>
                                <p className='font-bold text-primary'>{totalPoints}</p>
                            </div>
                            <div className='flex gap-1'>
                                <p className='font-bold'>Bonus Points: </p>
                                <p className='font-bold text-primary'>{bonusPoints}</p>
                            </div>
                            <div className='flex gap-1'>
                                <p className='font-bold'>Total Points: </p>
                                <p className='font-bold text-primary'>{(carbonSavingPoints || 0) + (totalPoints || 0) + (bonusPoints || 0)}</p>
                            </div>
                            {/* <div className="flex justify-center items-center gap-3">
                                <p className='font-bold'>Status</p>
                                <div className={`flex justify-end items-center border ${active ? `border-primary` : `border-inactive`} rounded-md h-full min-h-8 min-w-20`}>
                                    <label className="inline-flex items-center me-5 cursor-pointer h-full">
                                        <span className={`ms-3 text-base ${active ? `text-primary` : 'text-inactive'} font-bold dark:text-gray-300 mr-2`}>{active ? 'Active' : 'Inactive'}</span>
                                        <input type="checkbox" name={'active'} value={active} className="sr-only peer" onChange={() => setActive(!active)} checked={active} />
                                        <div className="relative w-8 h-4 bg-white border-black ring-1 ring-inactive rounded-full peer dark:bg-white peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.1 after:start-[0px] after:bg-inactive after:border-inactive peer-checked:after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-navBtn peer-checked:ring-primary peer-checked:bg-primary"></div>
                                    </label>
                                </div>
                            </div>
                            {/* <div className="flex justify-center items-center gap-3">
                                <p className='font-bold'>Challenge Of The Day</p>
                                <div className={`flex justify-end items-center border ${challengeOfTheDay ? `border-primary` : `border-inactive`} rounded-md h-full min-h-8 min-w-20`}>
                                    <label className="inline-flex items-center me-5 cursor-pointer h-full">
                                        <span className={`ms-3 text-base ${challengeOfTheDay ? `text-primary` : 'text-inactive'} font-bold dark:text-gray-300 mr-2`}>{challengeOfTheDay ? 'Yes' : 'No'}</span>
                                        <input type="checkbox" name={'challengeOfTheDay'} value={challengeOfTheDay} className="sr-only peer" onChange={() => setChallengeOfTheDay(!challengeOfTheDay)} checked={challengeOfTheDay} />
                                        <div className="relative w-8 h-4 bg-white border-black ring-1 ring-inactive rounded-full peer dark:bg-white peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.1 after:start-[0px] after:bg-inactive after:border-inactive peer-checked:after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-navBtn peer-checked:ring-primary peer-checked:bg-primary"></div>
                                    </label>
                                </div>
                            </div> */}
                        </div>
                    </div>
                    <div className='my-4 flex gap-2'>
                        <button
                            className={`font-bold text-base flex-grow rounded-md py-2 border-2 ${selectedTab === 'challenge-information' ? 'bg-white' : 'bg-navBtn'} ${selectedTab === 'challenge-information' ? 'border-primary' : 'border-navBtn'}`}
                            onClick={() => setSelectedTab('challenge-information')}
                        >
                            Challenge Information</button>
                        <button
                            className={`font-bold text-base flex-grow rounded-md py-2 border-2 ${selectedTab === 'submission-information' ? 'bg-white' : 'bg-navBtn'} ${selectedTab === 'submission-information' ? 'border-primary' : 'border-navBtn'}`}
                            onClick={() => setSelectedTab('submission-information')}
                        >
                            Submission Information</button>
                        <button
                            className={`font-bold text-base flex-grow rounded-md py-2 border-2 ${selectedTab === 'products/services' ? 'bg-white' : 'bg-navBtn'} ${selectedTab === 'products/services' ? 'border-primary' : 'border-navBtn'}`}
                            onClick={() => setSelectedTab('products/services')}
                        >
                            Products/Services</button>
                        <button
                            className={`font-bold text-base flex-grow rounded-md py-2 border-2 ${selectedTab === 'App Display Configuration' ? 'bg-white' : 'bg-navBtn'} ${selectedTab === 'App Display Configuration' ? 'border-primary' : 'border-navBtn'}`}
                            onClick={() => setSelectedTab('App Display Configuration')}
                        >
                            App Display Configuration</button>
                    </div>
                </div>
                {renderTab()}
                {/* {
                    !active && 
                    <div className='mt-3 flex justify-end'>
                        <ActionButton
                            text={'Save Draft'}
                            variant={'white'}
                            handleSubmit={handleSaveDraft}
                        />
                    </div>
                } */}
            </div>
            <ToastContainer
                position="top-right"
            />
        </div>
    );
};

export default CreateChallenge;